<!--=============================
=            BANNERS            =
==============================-->
<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Banner</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Single-line (desktop)
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-card class="transparent pa-5 elevation-0">
                <v-system-bar></v-system-bar>
                <v-toolbar flat>
                  <v-toolbar-title>My Document</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <div>
                    <v-switch v-model="sticky" label="Sticky Banner" hide-details></v-switch>
                  </div>
                </v-toolbar>
                <v-banner single-line :sticky="sticky">
                  We can't save your edits while you are in offline mode.
                  <template v-slot:actions>
                    <v-btn text color="deep-purple accent-4">Get Online</v-btn>
                  </template>
                </v-banner>
                <v-card-text class="grey lighten-4">
                  <v-sheet max-width="800" height="300" class="mx-auto"></v-sheet>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Two-line (mobile)
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-banner>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent cursus nec sem id malesuada.
                Curabitur lacinia sem et turpis euismod, eget elementum ex pretium.
                <template
                  v-slot:actions
                >
                  <v-btn text color="primary">Dismiss</v-btn>
                  <v-btn text color="primary">Retry</v-btn>
                </template>
              </v-banner>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Icon slot
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-banner two-line>
                <v-avatar slot="icon" color="deep-purple accent-4" size="40">
                  <v-icon icon="mdi-lock" color="white">mdi-lock</v-icon>
                </v-avatar>Three line text string example with two actions. One to two lines is preferable.
                Three lines should be considered the maximum string length on desktop in order to keep
                messages short and actionable.
                <template
                  v-slot:actions
                >
                  <v-btn text color="deep-purple accent-4">Action</v-btn>
                  <v-btn text color="deep-purple accent-4">Action</v-btn>
                </template>
              </v-banner>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- WIDGETS  -->

      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Actions slot
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <v-checkbox v-model="v0" label="Visible"></v-checkbox>
              <v-banner v-model="v0" single-line transition="slide-y-transition">
                No Internet connection
                <template v-slot:actions="{ dismiss }">
                  <v-btn text color="primary" @click="dismiss">Dismiss</v-btn>
                  <v-btn text color="primary">Retry</v-btn>
                </template>
              </v-banner>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    v0: true,
    sticky: false,
    singleLine: true,
    icon: "mdi-plus",

    elevation: 4,
    colors: ["red", "blue", "teal lighten-2", "warning lighten-1", "orange"],
    icons: [
      "mdi-access-point-network",
      "mdi-plus",
      "mdi-minus",
      "mdi-network-strength-2-alert",
      "mdi-earth"
    ]
  }),
  methods: {
    alert() {
      alert("Hello, World!");
    }
  }
};
</script>



<!--====  End of BANNERS  ====-->
